import React from 'react';
import { BundleProps } from 'utils/types';
import { LoadCompleteGeneral } from 'templates/Shared/LoadComplete';

export const LoadCompleteBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#A342C6',
  },
  emblemBadges = [],
  badges = [],
}) => {
  return (
    <LoadCompleteGeneral
      prices={prices}
      productList={productList}
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      emblemBadges={emblemBadges}
      className={'load-complete-bundle'}
      badges={badges}
    />
  );
};
